import { render } from "./SeoContentTextCMS.vue?vue&type=template&id=10418ee1"
import script from "../js/seo-content-text-cms?vue&type=script&lang=js"
export * from "../js/seo-content-text-cms?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__